module.exports = {
  behavior:     require('./behavior'),
  delegate:     require('./delegate'),
  delegateAll:  require('./delegateAll'),
  ignore:       require('./ignore'),
  keymap:       require('./keymap'),
};
